import React, { useEffect, useRef, useState } from "react";
import ApexCharts from 'react-apexcharts'
import { colors } from "../../common/Theme/Colors";
import NoDataFound from "../ManageTask/NoDataFound";
import Translate from "../../translation/utils/translateFunction";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { moduleTypes } from "../../common/users/userTypes";
import { FontSizes } from "../../common/Theme/Fonts";

const Piechart = ({
  optionsList,
  legends,
  selectedFilter,
  riskCountList,
  fromReport,
  graphHeight,
  selectedOptionFilters,
  customFilterSelectedDate,
}) => {
  const [series, setSeries] = useState();
  const [options, setOptions] = useState();
  const selectedFiltersRef = useRef(selectedOptionFilters);
  const navigate = useNavigate();
  const { userData } = useSelector((state) => state.formanagement);
  const data = userData?.moduleAccess?.find(
    (item) => Object.keys(item)[0] === moduleTypes.DASHBOARDFILTERS
  );

  useEffect(() => {
    selectedFiltersRef.current = selectedOptionFilters;
  }, [selectedOptionFilters]);

  useEffect(() => {
    if ((selectedFilter || fromReport) && optionsList) {
      setSeries(optionsList?.map((item) => item?.y));
      setOptions({
        chart: {
          events: {
            click: (event, chartContext, config) => {
              !fromReport && data?.dashboardFilter?.isEnable &&
                selectedFiltersRef &&
                navigate("riskFactorTask", {
                  state: {
                    selectedFilter: {
                      teamsFilter: selectedFiltersRef.current,
                      durationFilter: selectedFilter,
                      ...(customFilterSelectedDate && {
                        customFilterSelectedDate: customFilterSelectedDate,
                      }),
                    },

                    isFromDashboard: true,
                  },
                });
            },
          },
          width: 380,
          type: "donut",
        },
        states: {
          active: {
            filter: { type: "none", value: 0 },
          },
          hover: {
            filter: {
              type: "none",
            },
          },
        },
        colors: Object.values(legends),
        tooltip: {
          y: {
            formatter: (val) => {
              return "";
            },
            fillSeriesColor: true,
            title: {
              formatter: (seriesName) => {
                const hoveredItem = riskCountList?.find(
                  (item) => item?.type === seriesName
                );
                return `${hoveredItem?.type}: ${hoveredItem?.count}`;
              },
            },
          },
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              size: '65%'
            }
          }
        },
        labels: optionsList?.map((item) =>
          Translate(`dashboard:${item?.type}`)
        ),
        legend: {
          position: "bottom",
          markers: {
            fillColors: Object.values(legends),
          },
        },
        fill: {
          colors: Object.values(legends),
        },
        dataLabels: {
          enabled: true,
          formatter: (val) => {
            return parseFloat(val).toFixed(2) + "%";
          },
          style: {
            fontSize: FontSizes.regular,
            colors: [colors.grey_016],
          },
        },
        stroke: {
          width: optionsList?.find((item) => item?.y === 100) ? 0 : 2,
        },
        // responsive: [
        //   {
        //     breakpoint: 480,
        //     options: {
        //       chart: {
        //         width: "100%",
        //       },
        //       legend: {
        //         position: "bottom",
        //       },
        //     },
        //   },
        // ],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilter, optionsList, riskCountList, selectedOptionFilters]);

  return (
    <div>
      {options && series &&
        (optionsList?.length ? (
          <div className="donut" id="chart">
            <ApexCharts
              options={options}
              series={series}
              type='donut'
              width="100%"
              height={graphHeight ? graphHeight : "auto"}
            />
          </div>

        ) : (
          <NoDataFound message={Translate("dashboard:noDataMsg")} isCenter />
        ))}
    </div>
  );
};

export default Piechart;
